var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { svgIcon } from '../svg-icon';
/**
 * @tdr
 */
export var Eye = svgIcon(function (props) { return (React.createElement("svg", __assign({}, props, { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }),
    React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M11 8a3 3 0 1 1-6 0 3 3 0 0 1 6 0ZM9.8 8a1.8 1.8 0 1 1-3.6 0 1.8 1.8 0 0 1 3.6 0Z", clipRule: "evenodd" }),
    React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M8 14c-4.418 0-8-6-8-6s3.582-6 8-6 8 6 8 6-3.582 6-8 6ZM1.603 8.237 1.435 8c.052-.074.107-.153.168-.237.381-.53.93-1.232 1.604-1.93C4.608 4.381 6.307 3.2 8 3.2s3.392 1.181 4.793 2.633A17.752 17.752 0 0 1 14.565 8c-.052.074-.107.153-.168.237-.381.53-.93 1.232-1.604 1.93C11.392 11.619 9.693 12.8 8 12.8s-3.392-1.181-4.793-2.633a17.757 17.757 0 0 1-1.604-1.93Z", clipRule: "evenodd" }))); });
//# sourceMappingURL=Eye.js.map